import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import { useAppContext } from "../../provider/AppContextProvider";

const MobileBottomNav = () => {
  const { rightHandSectionTitleMap } = useAppContext();
  const isEventCalenderEnabled = rightHandSectionTitleMap["academyCalendarTitle"] && rightHandSectionTitleMap["academyCalendarTitle"].toLocaleLowerCase().includes("event") || false;
  return (
    <BottomNavigation showLabels>
      <BottomNavigationAction
        component={Link}
        to="/keydate-deadlines"
        label="Key Dates"
        className="fa-kit fa-calendar-canada"
      />
      {isEventCalenderEnabled ? (
        <BottomNavigationAction
          component={Link}
          to="/event-calendar"
          label="Events"
          className="fa-kit fa-academy"
        />
      ) :
        (<BottomNavigationAction
          component={Link}
          to="/academy-calendar"
          label="Academy"
          className="fa-kit fa-academy"
        />
        )}
      <BottomNavigationAction
        component={Link}
        to="/contacts"
        label="Contacts"
        className="fa-kit fa-contact-us"
      />
    </BottomNavigation>
  );
};

export default MobileBottomNav;